<template>
    <div id="ModuleSelectorTwo">
        <div class="title-text">
            <h1>{{ $t("manageYourBusinessModulesText") }}</h1>
            <h3 v-html="$t('allModulesAiChatbotAutomationText')"></h3>
        </div>
        <div class="content">
            <div class="module-selector-container">
                <div class="form-now" ref="formNow">
                    <h2>{{ $t("modulesText") }}</h2>
                    <div class="item" @click="toggleCheckbox('aiVoice')">
                        <div class="item-top">
                            <div class="item-icon">
                                <AiVoiceIcon />
                            </div>
                            <div class="item-text">{{ $t("aiVoiceText")}}</div>
                            <label class="item-checkbox">
                                <input
                                    @click="toggleCheckbox('aiVoice')"
                                    type="checkbox"
                                    v-model="selectedModules.aiVoice"
                                    data-module="dynamicTables"
                                >
                                <span class="checkmark"></span>
                            </label>
                        </div>
                        <div class="item-description">
                            <p>{{$t("aiVoiceDescriptionText")}}</p>
                        </div>
                    </div>
                    <div class="item" @click="toggleCheckbox('dynamicTables')">
                        <div class="item-top">
                            <div class="item-icon">
                                <TableIcon/>
                            </div>
                            <div class="item-text">{{ $t("dynamicTablesText") }}</div>
                            <label class="item-checkbox">
                                <input
                                    @click="toggleCheckbox('dynamicTables')"
                                    type="checkbox"
                                    v-model="selectedModules.dynamicTables"
                                    data-module="dynamicTables"
                                >
                                <span class="checkmark"></span>
                            </label>
                        </div>
                        <div class="item-description">
                            <p>{{ $t("dynamicTablesDescriptionText") }}</p>
                        </div>
                    </div>
                    <div class="item" @click="toggleCheckbox('remarketing')">
                        <div class="item-top">
                            <div class="item-icon">
                                <CrmIcon/>
                            </div>
                            <div class="item-text">{{ $t("reMarketingCampaignsText") }}</div>
                            <label class="item-checkbox">
                                <input
                                    @click="toggleCheckbox('remarketing')"
                                    type="checkbox"
                                    v-model="selectedModules.remarketing"
                                    data-module="remarketing"
                                >
                                <span class="checkmark"></span>
                            </label>
                        </div>
                        <div class="item-description">
                            <p>{{ $t("reMarketingCampaignsDescriptionText") }}</p>
                        </div>
                    </div>
                    <div class="item" @click="toggleCheckbox('calendar')">
                        <div class="item-top">
                            <div class="item-icon">
                                <CalendarIcon/>
                            </div>
                            <div class="item-text">{{ $t("calendarAndReservationSystemText") }}</div>
                            <label class="item-checkbox">
                                <input
                                    @click="toggleCheckbox('calendar')"
                                    type="checkbox"
                                    v-model="selectedModules.calendar"
                                    data-module="calendar"
                                >
                                <span class="checkmark"></span>
                            </label>
                        </div>
                        <div class="item-description">
                            <p>{{ $t("scheduleAppointmentsText") }}</p>
                        </div>
                    </div>
                    <div class="item" @click="toggleCheckbox('adReporting')">
                        <div class="item-top">
                            <div class="item-icon">
                                <AnalizIcon/>
                            </div>
                            <div class="item-text">{{ $t("advertisingAnalysisAndReportingText") }}</div>
                            <label class="item-checkbox">
                                <input
                                    @click="toggleCheckbox('adReporting')"
                                    type="checkbox"
                                    v-model="selectedModules.adReporting"
                                    data-module="adReporting"
                                >
                                <span class="checkmark"></span>
                            </label>
                        </div>
                        <div class="item-description">
                            <p>{{ $t("analyzeVisitorsAndAdsText") }}</p>
                        </div>
                    </div>
                    <div class="item" @click="toggleCheckbox('formSurvey')">
                        <div class="item-top">
                            <div class="item-icon">
                                <FormIcon />
                            </div>
                            <div class="item-text">{{ $t("formAndSurveyModuleText") }}</div>
                            <label class="item-checkbox">
                                <input
                                    @click="toggleCheckbox('formSurvey')"
                                    type="checkbox" 
                                    v-model="selectedModules.formSurvey"
                                    data-module="formSurvey"
                                >
                                <span class="checkmark"></span>
                            </label>
                        </div>
                        <div class="item-description">
                            <p>{{ $t("analyzeCustomerBehaviorText") }}</p>
                        </div>
                    </div>
                    <div class="item" @click="toggleCheckbox('processManagement')">
                        <div class="item-top">
                            <div class="item-icon">
                                <TaskIcon />
                            </div>
                            <div class="item-text">{{ $t("processAndTaskManagementModuleText") }}</div>
                            <label class="item-checkbox">
                                <input
                                    @click="toggleCheckbox('processManagement')"
                                    type="checkbox" 
                                    v-model="selectedModules.processManagement"
                                    data-module="processManagement"
                                >
                                <span class="checkmark"></span>
                            </label>
                        </div>
                        <div class="item-description">
                            <p>{{ $t("manageBusinessProcessesText") }}</p>
                        </div>
                    </div>
                    <div class="item" @click="toggleCheckbox('videoCall')">
                        <div class="item-top">
                            <div class="item-icon">
                                <VideocallIcon/>
                            </div>
                            <div class="item-text">{{ $t("videoAndAudioCallScreenSharingModuleText") }}</div>
                            <label class="item-checkbox">
                                <input
                                    @click="toggleCheckbox('videoCall')"
                                    type="checkbox" 
                                    v-model="selectedModules.videoCall"
                                    data-module="videoCall"
                                >
                                <span class="checkmark"></span>
                            </label>
                        </div>
                        <div class="item-description">
                            <p>{{ $t("webChatPlatformText") }}</p>
                        </div>
                    </div>
                    <div class="item" @click="toggleCheckbox('websiteAnalysis')">
                        <div class="item-top">
                            <div class="item-icon">
                                <WebSiteIcon/>
                            </div>
                            <div class="item-text">{{ $t("webSiteAnalysisAndSegmentationText") }}</div>
                            <label class="item-checkbox">
                                <input
                                    @click="toggleCheckbox('websiteAnalysis')"
                                    type="checkbox" 
                                    v-model="selectedModules.websiteAnalysis"
                                    data-module="websiteAnalysis"
                                >
                                <span class="checkmark"></span>
                            </label>
                        </div>
                        <div class="item-description">
                            <p>{{ $t("analyzeWebsiteVisitorsText") }}</p>
                        </div>
                    </div>
                    <div class="item" @click="toggleCheckbox('ticketSystem')">
                        <div class="item-top">
                            <div class="item-icon">
                                <TicketIcon/>
                            </div>
                            <div class="item-text">{{ $t("ticketManagementSystemText") }}</div>
                            <label class="item-checkbox">
                                <input
                                    @click="toggleCheckbox('ticketSystem')"
                                    type="checkbox" 
                                    v-model="selectedModules.ticketSystem"
                                    data-module="ticketSystem"
                                >
                                <span class="checkmark"></span>
                            </label>
                        </div>
                        <div class="item-description">
                            <p>{{ $t("manageTicketsText") }}</p>
                        </div>
                    </div>
                    <div class="item" @click="toggleCheckbox('webPush')">
                        <div class="item-top">
                            <div class="item-icon">
                                <TriggerIcon/>
                            </div>
                            <div class="item-text">{{ $t("webPushAndPopupModuleText") }}</div>
                            <label class="item-checkbox">
                                <input
                                    @click="toggleCheckbox('webPush')"
                                    type="checkbox" 
                                    v-model="selectedModules.webPush"
                                    data-module="webPush"
                                >
                                <span class="checkmark"></span>
                            </label>
                        </div>
                        <div class="item-description">
                            <p>{{ $t("webPushAndPopupModuleDescriptionText") }}</p>
                        </div>
                    </div>
                </div>
                <!-- Scroll indicator butonu -->
                <div 
                    class="scroll-indicator"
                    v-show="showScrollDownButton"
                    @click="scrollDown"
                >
                    <ArrowDownIcon class="scroll-icon" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import VideocallIcon from "../../icon/VideocallIcon.vue";
import CalendarIcon from "../../icon/CalendarIcon.vue";
import CrmIcon from "../../icon/CrmIcon.vue";
import TriggerIcon from "../../icon/TriggerIcon.vue";
import WebSiteIcon from "../../icon/WebSiteIcon.vue";
import FormIcon from "../../icon/FormIcon.vue";
import TaskIcon from "../../icon/TaskIcon.vue";
import AnalizIcon from "../../icon/AnalizIcon.vue";
import TicketIcon from "../../icon/TicketIcon.vue";
import TableIcon from "../../icon/TableIcon.vue";
import ArrowDownIcon from "../../icon/ArrowDownIcon.vue";
import AiVoiceIcon from "../../icon/AiVoiceIcon.vue";
import { loadFromLocalStorage, saveToLocalStorage } from "../../../utils/formStore";

export default {
    name: "ModuleSelectorTwo",
    components: {
        VideocallIcon,
        CalendarIcon,
        CrmIcon,
        TriggerIcon,
        WebSiteIcon,
        FormIcon,
        TaskIcon,
        AnalizIcon,
        TicketIcon,
        TableIcon,
        ArrowDownIcon,
        AiVoiceIcon,
    },
    data() {
        return {
            selectedModules: {
                formSurvey: false,
                processManagement: false,
                videoCall: false,
                calendar: false,
                websiteAnalysis: false,
                adReporting: false,
                ticketSystem: false,
                webPush: false,
                remarketing: false,
                dynamicTables: false,
                aiVoice: false,
            },
            showScrollDownButton: false
        };
    },
    methods: {
        toggleCheckbox(moduleKey) {
            this.selectedModules[moduleKey] = !this.selectedModules[moduleKey];
            saveToLocalStorage({
                moduleSelectionsTwo: this.selectedModules
            });
        },
        scrollDown() {
            const formNow = this.$refs.formNow;
            if (formNow) {
                formNow.scrollBy({
                    top: 200,
                    behavior: 'smooth'
                });
            }
        },
        handleScroll() {
            const formNow = this.$refs.formNow;
            if (formNow) {
                const { scrollTop, scrollHeight, clientHeight } = formNow;
                this.showScrollDownButton = scrollTop + clientHeight < scrollHeight - 50;
            }
        }
    },
    watch: {
        selectedModules: {
            handler(newVal) {
                saveToLocalStorage({ moduleSelectionsTwo: newVal });
            },
            deep: true
        }
    },
    created() {
        const saved = loadFromLocalStorage().moduleSelectionsTwo || {};
        this.selectedModules = {
            formSurvey: saved.formSurvey || false,
            processManagement: saved.processManagement || false,
            videoCall: saved.videoCall || false,
            calendar: saved.calendar || false,
            websiteAnalysis: saved.websiteAnalysis || false,
            adReporting: saved.adReporting || false,
            ticketSystem: saved.ticketSystem || false,
            webPush: saved.webPush || false,
            remarketing: saved.remarketing || false,
            dynamicTables: saved.dynamicTables || false,
            aiVoice: saved.aiVoice || false
        };
    },
    mounted() {
        this.$nextTick(() => {
            const formNow = this.$refs.formNow;
            if (formNow) {
                formNow.addEventListener('scroll', this.handleScroll);
                this.handleScroll();
            }
        });
    },
    beforeDestroy() {
        const formNow = this.$refs.formNow;
        if (formNow) {
            formNow.removeEventListener('scroll', this.handleScroll);
        }
    }
};
</script>

<style lang="scss" scoped>
#ModuleSelectorTwo {
    display: flex;
    flex-direction: column;
    height: 100%;
    overflow: auto;
    background-image: url("../../../assets/BackgroundOne.png");
    background-repeat: no-repeat;
    background-size: cover;

    .title-text {
        font-family: 'Plus Jakarta Sans', sans-serif;
        padding: 0 20px;
        animation: slideDown 0.8s ease;

        h1 {
            font-size: 2rem;
            color: #272657;
            font-weight: bold;

            @media (max-width: 768px) {
                font-size: 1.8rem;
                text-align: center;
            }
        }

        h3 {
            color: #64607D;
            font-weight: 100;

            @media (max-width: 768px) {
                font-size: 1rem;
                text-align: center;
            }
        }
    }

    @media (max-width: 768px) {
        .module-selector-container{
            width: 92% !important;
            height: 43vh !important;
        }
        .form-now{
            height: 45vh !important;
        }
    }

    .content {
        display: flex;
        justify-content: center;
        padding: 0 20px;

        .module-selector-container {
            padding: 30px;
            background: #fff;
            width: 600px;
            height: 48vh;
            border-radius: 20px;
            box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.1);
            animation: fadeIn 1s ease;
            position: relative;

            @media (max-width: 768px) {
                width: 100%;
                padding: 20px;
                border-radius: 15px;
            }

            .form-now {
                margin: auto;
                font-family: Arial, sans-serif;
                height: 48vh;
                overflow-y: auto;

                h2 {
                    text-align: left;
                    margin-top: 0px;
                    color: #272657;
                }

                .item {
                    position: relative;
                    display: flex;
                    align-items: flex-start;
                    flex-direction: column;
                    padding: 15px 20px;
                    border: 1px solid #ddd;
                    border-radius: 10px;
                    margin-bottom: 15px;
                    transition: all 0.5s ease;
                    cursor: pointer;
                    overflow: hidden;
                    opacity: 0;
                    animation: slideUp 0.5s ease forwards;

                    @for $i from 1 through 11 {
                        &:nth-child(#{$i}) {
                            animation-delay: #{$i * 0.2}s;
                        }
                    }

                    @media (max-width: 768px) {
                        padding: 12px 15px;
                    }

                    .item-top {
                        display: flex;
                        align-items: center;
                        justify-content: space-between;
                        width: 100%;
                        flex-wrap: nowrap;

                        @media (max-width: 768px) {
                            flex-wrap: nowrap;
                            gap: 10px;

                            .item-text {
                                font-size: 14px;
                                margin-left: 10px;
                                flex: 1;
                                white-space: nowrap;
                                overflow: hidden;
                                text-overflow: ellipsis;
                            }

                            .item-icon {
                                flex-shrink: 0;
                                width: 20px;
                                height: 20px;
                            }

                            .item-checkbox {
                                flex-shrink: 0;
                            }
                        }

                        .item-icon {
                            width: 30px;
                            height: 30px;

                            @media (max-width: 768px) {
                                width: 25px;
                                height: 25px;
                            }
                        }

                        .item-text {
                            flex-grow: 1;
                            margin-left: 15px;
                            font-size: 18px;
                            color: #444;
                            text-align: left;

                            @media (max-width: 768px) {
                                font-size: 16px;
                                margin-left: 10px;
                            }
                        }

                        .item-checkbox {
                            position: relative;
                            cursor: pointer;

                            input {
                                position: absolute;
                                opacity: 0;
                                cursor: pointer;

                                &:checked ~ .checkmark {
                                    background-color: #5d5b8d;
                                    border: 1px solid #5d5b8d;
                                }

                                &:checked ~ .checkmark::after {
                                    display: block;
                                }
                            }

                            .checkmark {
                                height: 24px;
                                width: 24px;
                                background-color: #fff;
                                border: 1px solid #ccc;
                                border-radius: 50%;
                                display: inline-block;
                                position: relative;

                                &::after {
                                    content: "";
                                    position: absolute;
                                    display: none;
                                    left: 8px;
                                    top: 4px;
                                    width: 6px;
                                    height: 10px;
                                    border: solid #fff;
                                    border-width: 0 2px 2px 0;
                                    transform: rotate(45deg);
                                }
                            }

                            @media (max-width: 768px) {
                                .checkmark {
                                    height: 20px;
                                    width: 20px;

                                    &::after {
                                        left: 6px;
                                        top: 3px;
                                        width: 5px;
                                        height: 9px;
                                    }
                                }
                            }
                        }
                    }

                    .item-description {
                        max-height: 0;
                        opacity: 0;
                        margin-top: 0;
                        transition: all 0.5s ease;
                        overflow: hidden;
                        width: 100%;

                        p {
                            margin: 10px 0 0 0;
                            font-size: 14px;
                            color: #666;
                            line-height: 1.5;

                            @media (max-width: 768px) {
                                font-size: 13px;
                                line-height: 1.4;
                            }
                        }
                    }

                    &:hover {
                        box-shadow: 0px 0px 20px 0px rgba(232, 228, 243);
                        transform: scale(1.02);
                        transition: all 0.5s ease;

                        .item-description {
                            max-height: 200px;
                            opacity: 1;
                            margin-top: 10px;
                        }
                    }

                    @media (hover: none) {
                        &:active {
                            box-shadow: 0px 0px 20px 0px rgba(232, 228, 243);
                            transform: scale(1.01);

                            .item-description {
                                max-height: 200px;
                                opacity: 1;
                                margin-top: 10px;
                            }
                        }
                    }
                }
            }
        }
    }
}

@keyframes slideDown {
    from {
        opacity: 0;
        transform: translateY(-50px);
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
}

@keyframes fadeIn {
    from {
        opacity: 0;
    }
    to {
        opacity: 1;
    }
}

@keyframes slideUp {
    from {
        opacity: 0;
        transform: translateY(30px);
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
}

.scroll-indicator {
    position: absolute;
    left: 0;
    right: 0;
    bottom: -50px;
    margin: auto;
    width: fit-content;
    transform: translateY(-20px);
    background: #5d5b8d;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    box-shadow: 0 4px 12px rgba(0,0,0,0.15);
    transition: all 0.3s ease;
    z-index: 1000;
    padding: 5px;

    &:hover {
        background: #4a4870;
        transform: scale(1.1);
    }

    &:active {
        transform: scale(0.95);
    }

    .scroll-icon {
        color: white;
        font-size: 18px;
    }
}

@media (max-width: 768px) {
    .scroll-indicator {
        display: none !important;
    }
    
    .module-selector-container {
        width: 92% !important;
        height: 43vh !important;
    }
    .form-now{
        height: 45vh !important;
    }
}
</style>